module.exports = __webpack_public_path__ + "static/lighthouse-seo-10afb1e158d58acd821f79a464c79894.png";